import type { IMarkPointSpec, ISpec } from '@visactor/vchart'
import { selector, selectorWithDynamicFilter } from '../../../../../dataSelector'
import { MeasureId } from 'src/dataReshape/constant'
import type { Datum, SpecPipelineContext, VChartSpecPipe } from 'src/types'
import { isSubset } from './utils'
import { flatReshapeMeasures } from 'src/pipeline/utils'
import { pickWithout } from '@visactor/vutils'
import { generateAnnotationPointPipe } from './annotationPointCommon'

const getSeriesMeasureIds = (context: SpecPipelineContext, seriesIndex: number) => {
  const foldInfo = context.advancedVSeed.datasetReshapeInfo?.[0]?.foldInfoList?.[seriesIndex]
  return Object.keys(foldInfo?.foldMap ?? {})
}

export const annotationPointOfDualAxis: VChartSpecPipe = generateAnnotationPointPipe({
  findSelectedDatas: (options) => {
    const { dataset, selector: s, measureId, dynamicFilter, context } = options
    return dataset.reduce((res: Datum[], d: Datum) => {
      const { advancedVSeed } = context
      const allMeasureIds = flatReshapeMeasures(advancedVSeed.reshapeMeasures ?? []).map((m) => m.id)
      const pickedDatum = pickWithout(
        d,
        allMeasureIds.filter((id) => id !== d[MeasureId]),
      )

      const shouldSelect = dynamicFilter
        ? selectorWithDynamicFilter(pickedDatum, dynamicFilter, s)
        : selector(pickedDatum, s)

      if (shouldSelect && (!measureId || pickedDatum[MeasureId] === measureId)) {
        res.push(pickedDatum)
      }

      return res
    }, [])
  },
  generateMarkPoint: (datum: Datum, spec: ISpec, context: SpecPipelineContext) => {
    const { advancedVSeed } = context
    const allMeasureIds = flatReshapeMeasures(advancedVSeed.reshapeMeasures ?? []).map((m) => m.id)
    const selectedMeasureId = datum[MeasureId]
    return spec.series?.flatMap((_series: any, index: number) => {
      const seriesMeasureIds = getSeriesMeasureIds(context, index)
      if (selectedMeasureId && seriesMeasureIds.length && !seriesMeasureIds.includes(String(selectedMeasureId))) {
        return []
      }

      return {
        relativeSeriesIndex: index,
        coordinate: (data: Datum[]) => {
          return data.find((item) => {
            return isSubset(
              datum,
              item,
              allMeasureIds.filter((id) => id !== item[MeasureId]),
            )
          })
        },
      } as IMarkPointSpec
    })
  },
})
